import "../css/header.scss";
import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const cartCount = useMemo(
    () =>
      cartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0),
    [cartItems]
  );

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="site-header__bar">
        <div className="site-header__left">
          <Link onClick={toTop} to="/" className="site-header__logo">
            <img
              src={`${process.env.PUBLIC_URL || ""}/head/averlynxstore-logo.svg`}
              alt="averlynxstore"
              className="site-header__logo-img"
            />
          </Link>
          <nav className="site-header__nav" aria-label="Main">
            <Link onClick={toTop} to="/shop" className="site-header__nav-link">
              SHOP
            </Link>
            <Link onClick={toTop} to="/about" className="site-header__nav-link">
              ABOUT US
            </Link>
            <Link
              onClick={toTop}
              to="/contact"
              className="site-header__nav-link"
            >
              CONTACT US
            </Link>
            <details className="site-header__more">
              <summary className="site-header__nav-link">MORE</summary>
              <div className="site-header__more-menu">
                <Link onClick={toTop} to="/faqs">FAQs</Link>
                <Link onClick={toTop} to="/policies">Policy Center</Link>
                <Link onClick={toTop} to="/cookies">Cookie Policy</Link>
                <Link onClick={toTop} to="/privacy">Privacy Policy</Link>
                <Link onClick={toTop} to="/terms">Terms</Link>
                <Link onClick={toTop} to="/shipping">Shipping</Link>
                <Link onClick={toTop} to="/returns">Returns</Link>
              </div>
            </details>
          </nav>
        </div>

        <div className="site-header__right">
          <Link
            onClick={toTop}
            to="/cartpage"
            className="site-header__icon-btn site-header__cart-link"
            aria-label={`Shopping bag, ${cartCount} items`}
          >
            <FiShoppingBag className="site-header__icon" strokeWidth={1.25} />
            {cartCount > 0 ? (
              <span className="site-header__cart-badge">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            ) : null}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
